module.exports = __webpack_public_path__ + "static/author-3-5456a7c1b21d29a540fea45a16ac8e28.jpg";